<template>
  <div>
    <SPreloader />
    <SLandingTopBar />
    <div class="header-spacer--standard"></div>
    <div class="container">
      <div class="login-content">
        <SLoginCard />
      </div>
    </div>
    <FooterUnlogged />
    <CookiesAndPrivacy v-if="!storageCookies" @cookies-privacy="accept" />
  </div>
</template>

<script>
import SLandingTopBar from "@/material-components/organisms/SLandingTopBar.vue";
import SPreloader from "@/components/organisms/SPreloader.vue";
import SLoginCard from "@/components/organisms/SLoginCard.vue";
import FooterUnlogged from "@/templates/FooterUnlogged";

export default {
  name: "Login",
  components: {
    SLandingTopBar,
    SPreloader,
    SLoginCard,
    FooterUnlogged,
  },
  data() {
    return {
      cookiesPrivacy: localStorage.getItem("cookies_privacy"),
    };
  },
  methods: {
    accept(a) {
      this.cookiesPrivacy = a;
    },
  },
  computed: {
    storageCookies() {
      return this.cookiesPrivacy;
    },
  },
};
</script>
<style lang="scss" scoped>
.login-content {
  margin: auto;
}
@media screen and (min-width: 769px) and (max-width: 1023px) {
  .login-content {
    margin-top: 130px;
  }
}
@media screen and (min-width: 1024px) {
  .login-content {
    margin-top: 80px;
  }
}
@media screen and (max-width: 768px) {
  .login-content {
    margin-top: 168px;
  }
}
</style>
